import axios from 'axios';
import Qs from 'qs';
import { isAuth, getToken } from './auth';
import { router } from '@/router';
import { baseURL } from '@/api/const';

const config = {
  timeout: 15000,
  baseURL: baseURL,
  headers: {
    'Content-Type': 'multipart/form-data;charset=utf-8',
    'X-Requested-With': 'XMLHttpRequest'
  },
  withCredentials: true,
  transformRequest: [
    function (data) {
      data = Qs.stringify(data);
      return data;
    }
  ]
};

const upload = axios.create(config);
/*
http.defaults.baseURL = 'http://youka.kaichen.com/admin/'
http.defaults.timeout = 5000
http.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8'
http.defaults.headers.post['X-Requested-With'] = 'XMLHttpRequest'
http.defaults.withCredentials = true
*/
upload.interceptors.request.use(
  function (config) {
    if (isAuth()) {
      config.headers.Token = getToken();
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

upload.interceptors.response.use(
  function (response) {
    let code = response.data.code;
    if (code === 403) {
      router.replace({
        path: '/login',
        query: { redirect: router.currentRoute.query }
      });
    } else {
      return response.data;
    }
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default upload;
